/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker') || !customElements.get('variant-picker-curated-packs')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector:not(.option-selector--custom)');
      this.nativeSelector = document.getElementById(`variants-${this.section.dataset.section}`);
      this.data = this.getVariantData();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.quantity = 1;

      this.updateAvailability();
      this.updateAddToCartButton();
      this.addEventListener('change', this.handleVariantChange.bind(this));
      this.applySearchParams();
      this.updateFinalSale();
      // this.sizeChart = this.querySelector('.size-chart-link');
      // if(this.sizeChart){
      //   this.sizeChart.addEventListener('click', this.handleSizeFitClick.bind(this));
      // }
      this.querySelectorAll('.fit-chart-drawer-link, .size-chart-link').forEach(el => {
        el.addEventListener('click', this.handleSizeFitClick.bind(this));
      })

      if(this.productForm.classList.contains('js-outfit-product-form')){
        document.querySelectorAll('#size-fit .chart-images').forEach((e, i) => {if(i != 0){e.classList.add('hidden')}});
      }
      this.updateSelectedOptText();
      this.runABTest();
      
      if(this.section.querySelector('.option-selector.option-selector--combine-listing')){
        if(this.section.classList.contains('cart-edit-popup') || this.closest('.modal-quickbuy-popup-container') || this.closest('.quickbuy-container')){
          this.section.querySelector('.option-selector.option-selector--combine-listing').remove();
          return;
        }
        this.combinedListingContainer = this.section.querySelector('.option-selector.option-selector--combine-listing');
        this.combinedListingContainer.classList.add('loading');
        this.sectionId = document.querySelector('.section-main-product').id;
        this.handle = this.section.dataset.productHandle;
        if(this.combinedListingContainer.querySelector(`input:checked`).dataset.subtext != ''){
          document.querySelectorAll('.option-selector.option-selector--combine-listing').forEach(e => {
            e.querySelector('.option-sub-text').innerHTML = `<span class="small">${e.querySelector(`input:checked`).dataset.subtext}</span>`;
            e.querySelector('.option-sub-text').classList.remove('hidden')
          })
          // this.combinedListingContainer.querySelector('.option-sub-text').innerHTML = `<span class="small">${this.combinedListingContainer.querySelector(`input:checked`).dataset.subtext}</span>`;
          // this.combinedListingContainer.querySelector('.option-sub-text').classList.remove('hidden');
        }

        (async () => {
          const nextHandle = this.combinedListingContainer.querySelector(`input:not(:checked)`).dataset.productHandle;
          const currentHandle = this.combinedListingContainer.querySelector(`input:checked`).dataset.productHandle;
          const currentSection = document.querySelector('.section-main-product');
          if(document.querySelectorAll('.section-main-product').length > 2){
            return;
          }
          let template = '';
          if(location.href.includes('product-packs-new-design')){
            template = '?view=product-packs-new-design';
          }
          const otherProductData = await this.getOtherHTML(`${nextHandle}${template}`);
          if(!currentSection.id.includes(currentHandle) && currentSection.dataset.updated != 'true'){
            currentSection.id = `${currentSection.id}-${currentHandle}`;
            currentSection.setAttribute('data-product', currentHandle);
            currentSection.setAttribute('data-updated', 'true');
          }
          const newSection = otherProductData.querySelector('.section-main-product');
          setTimeout(function(){
            if (newSection && document.querySelectorAll('.section-main-product').length < 2) {
              if(!document.querySelector(`#${newSection.id}-${nextHandle}`)){
                newSection.id = `${newSection.id}-${nextHandle}`;
                newSection.setAttribute('data-product', nextHandle);
                newSection.classList.add('hidden-soft');
                // const title = newSection.querySelector('.title-row h1.product-title');
                // const div = document.createElement('div');
                // div.className = title.className;
                // div.setAttribute('data-product-title', title.dataset.productTitle);
                // div.innerHTML = title.innerHTML;
                // title.parentNode.replaceChild(div, title);
                currentSection.insertAdjacentElement('afterend', newSection);
                document.querySelectorAll('.option-selector.option-selector--combine-listing').forEach(styleEl => {
                  styleEl.classList.remove('loading');
                });
                StampedFn.reloadUGC();
              }
            }
          }, 1000);
        })();
      }
      this.closest('.js-product').addEventListener('on:quantity:change', this.updateQuantity.bind(this));

      this.setAttribute('loaded', '');
    }

    updateSelectedOptText(evt){
      this.section.querySelectorAll('.option-selector').forEach(el => {
        if(el.querySelector('input:checked') && el.querySelector('.option-selector__label-value.js-color-text') != undefined){
          el.querySelector('.option-selector__label-value').innerText = el.querySelector('input:checked').value;
        }
        if(el.querySelector('input:checked') && el.querySelector('.option-selector__label-value.js-option-text') != undefined){
          if(el.classList.contains('option-selector--combine-listing')){
            const val = el.querySelector('input:checked').value;
            if(el.querySelector('.option-selector__label-value.js-option-text strong') && el.querySelector('.option-selector__label-value.js-option-text strong').innerText == val && el.querySelector('.option-selector__label-value.js-option-text').innerText.includes('Switch')){
            }else{
              el.querySelector('.option-selector__label-value.js-option-text').innerHTML =  `<strong>${el.querySelector('input:checked').value}</strong>`;
            }
          }
          if(el.dataset.option == 'Length' || el.dataset.option == 'Style'){
            if(el.dataset.option == 'Length'){
              if((el.querySelector('input:checked').value == 'Reg') && el.querySelector('.option-selector__label-value.js-option-text').innerText.includes('Switch')){
              }else{
                el.querySelector('.option-selector__label-value.js-option-text').innerHTML =  `<strong>${el.querySelector('input:checked').value}</strong>`;
              }
            }
            if(el.dataset.option == 'Style'){
              const val = el.querySelector('input:checked').value;
              if(el.querySelector('.option-selector__label-value.js-option-text strong') && el.querySelector('.option-selector__label-value.js-option-text strong').innerText == val && el.querySelector('.option-selector__label-value.js-option-text').innerText.includes('Switch')){
              }else{
                el.querySelector('.option-selector__label-value.js-option-text').innerHTML =  `<strong>${el.querySelector('input:checked').value}</strong>`;
              }
            }
          }else{
            el.querySelector('.option-selector__label-value.js-option-text').innerText = el.querySelector('input:checked').value == 'Singles' ? '1' : el.querySelector('input:checked').value;
          }
        }
      })
    }

    runABTest(){
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.showSubText(evt);
      if(evt.target.closest('.option-selector').classList.contains('option-selector--combine-listing')){
        this.handleCombineListingClick(evt);
      }

      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;
      
      evt.target.closest('.option-selector').querySelector('.label').classList.remove('label--contains-error');
      if(evt.target.closest('.option-selector').querySelector('.error'))
        evt.target.closest('.option-selector').querySelector('.error').classList.add('hidden');
      
      if(evt.target.closest('.option-selector').classList.contains('open')){
        evt.target.closest('.option-selector').classList.remove('open');
        const allBtn = evt.target.closest('variant-picker').querySelectorAll('.mobile-option-expander-btn');
        allBtn.forEach(btn => {
          if(window.innerWidth < 768){
            btn.querySelectorAll('span')[0].innerText = this.variant.option1;
          }
          btn.classList.remove('open');
        });
      }

      const optionName = evt.target.closest('.option-selector').dataset.option;
      if (getCookie("fit_variant_sub_text") == 'true') {
        if(evt.target.closest('.option-selector').querySelector('.length-sub-text') != undefined && evt.target.closest('.option-selector').querySelector('.fit-sub-text') != undefined){
          if(optionName == 'Length'){
            if(evt.target.dataset.subtext != ''){
              evt.target.closest('.option-selector').querySelector('.length-sub-text').innerText = evt.target.dataset.subtext;
            }
          }
          if(optionName == 'Fit'){
            if(evt.target.dataset.subtext != ''){
              evt.target.closest('.option-selector').querySelector('.fit-sub-text').innerText = evt.target.dataset.subtext;
            }
          }
        }
      }
      if(optionName == 'Size' || optionName == 'Waist'){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'pdp_click',
          eventParameter:{
            event_trigger_type: 'select_size_click',
            event_trigger_value: evt.target.value
          },
          custom_event_label: 'select_size_click',
          custom_event_value: evt.target.value
        });
      }
      if(optionName == 'Color'){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'pdp_click',
          eventParameter:{
            event_trigger_type: 'select_color_click',
            event_trigger_value: evt.target.value
          },
          custom_event_label: 'select_color_click',
          custom_event_value: evt.target.value
        });
      }

      if(this.section.classList.contains('cart-upsell-product') ){
        let variantId = '';
        if(!this.variant){
          variantId = this.data.variants.find(v => v.options[0] == this.selectedOptions[0]);
        }else{
          variantId = this.variant;
        }

        if(variantId != '' && variantId != undefined && this){
          (async () => {
            try {
              const baseUrl = window.location.origin;
              const htmlResponse = await this.renderSection(baseUrl + this.dataset.url + '?sections=product-block&id='+variantId.id);
              const innerHTML = JSON.parse(htmlResponse)['product-block'];
              const htmlDoc = new DOMParser().parseFromString(innerHTML, 'text/html');
              const productBlock = htmlDoc.querySelector('.product-block');
              const currentImage = productBlock.querySelector('.product-block__image[data-media-id="'+variantId.featured_media.id+'"]');
        
              if (productBlock && productBlock.dataset.productId) {
                this.closest('.product-block').querySelector('.product-block__image').innerHTML = currentImage.innerHTML;
              }
            } catch (error) {
              console.error(`Error loading product :`, error);
            }
          })();
        }
      }
      
      this.updateUrl(evt);
      this.updateVariantInput();
      this.updateAddToCartButton();
      this.updateAvailability(evt);
      if(!this.productForm.classList.contains('js-outfit-product-form')){
        this.updatePrice();
      }
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateBarcode();
      VariantPicker.updateLabelText(evt);
      this.updateBIS();

      if(this.productForm.classList.contains('js-outfit-product-form')){
        const productId = evt.target.closest('.outfit-product').dataset.productId;
        if(document.querySelector(`#size-fit [data-product-chart="chart-${productId}"]`).innerHTML != ''){
          document.querySelectorAll('#size-fit .chart-images').forEach(e => e.classList.add('hidden'));
          document.querySelector(`#size-fit [data-product-chart="chart-${productId}"]`).classList.remove('hidden');
        }
        if (this.variant) {
          this.productForm.querySelector(`#id-${productId}`).value = this.variant.id;
        }
      }
      
      if(!this.variant){
        if (!this.section) return;
        if(this.section.querySelector('.product-info-block')){
          this.section.querySelector('.product-info-block').hidden = true;
        }
      }else{
        if(this.section.querySelector('.product-info-block')){
          this.section.querySelector('.product-info-block').hidden = false;
        }
      }

      if(this.productForm.classList.contains('js-outfit-product-form')){
        const productId = evt.target.closest('.outfit-product').dataset.productId;
        if(this.section.querySelector(`.media-gallery#outfit-product-${productId}`) && evt.target.closest('.option-selector').dataset.option == 'Color'){
          this.currentProductMedia = this.section.querySelector(`.media-gallery#outfit-product-${productId}`);
          this.section.querySelectorAll('media-gallery').forEach(el => el.classList.add('hidden'));
          this.currentProductMedia.classList.remove('hidden');
        }
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            product: productId,
            form: this.productForm,
            variant: this.variant,
            allVariants: this.data.variants,
            selectedOptions: this.selectedOptions
          }
        }));
        return;
      }
      if(document.querySelector('body').classList.contains('template-suffix-curated-packs') && evt.target.closest('.option-selector').classList.contains('option-selector--custom') && evt.target.value != 'Singles'){
        return;
      }
      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          allVariants: this.data.variants,
          selectedOptions: this.selectedOptions,
          optName: optionName,
          optIndex: evt.target.closest('.option-selector').dataset.optionIndex 
        }
      }));
    }

    renderSection = async (sectionId) => {
      try {
        const response = await fetch(sectionId);
        if (response.ok) {
          return await response.text();
        } else {
          throw new Error('Failed to load section');
        }
      } catch (error) {
        console.error(error);
      }
    };

    handleSizeFitClick(evt){
      evt.preventDefault();
      if(evt.target.dataset.chartType == 'accordian'){
        const targetId = evt.target.getAttribute('href'); // Get target ID
        const targetElement = this.section.querySelector(targetId);
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

        if(!targetElement.querySelector('.disclosure[open]')){
          targetElement.querySelector('.disclosure__title').dispatchEvent(new Event('click', { bubbles: true }));
        }
      }

      if(evt.target.dataset.chartType == 'drawer'){
        if(this.section.querySelector('.js-product-drawer')) {
          this.section.querySelector('.js-product-drawer').open(evt.target);
          if(this.section.querySelectorAll('.guide-wrapper').length > 1){
            this.section.querySelectorAll('.guide-wrapper').forEach(e => {
              e.classList.add('hidden');
              if(e.classList.contains(`${evt.target.dataset.content}-guide-wrapper`)){
                e.classList.remove('hidden');
              }
            })
          }
        }
      }

      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'pdp_click',
        // parameter:'whats_my_size_click',
        eventParameter:{
          event_trigger_type: 'whats_my_size_click',
          event_trigger_value: evt.target.closest('product-form').dataset.productTitle
        },
        custom_event_label: 'whats_my_size_click',
        custom_event_value: evt.target.closest('product-form').dataset.productTitle
      });
    }

    showSubText(evt){
      // console.log(evt.target.dataset.subtext, evt.target.closest('.option-selector').querySelector('.option-sub-text'));
      if(evt.target.dataset.subtext != '' && evt.target.closest('.option-selector').querySelector('.option-sub-text')){
        const subTextContainer = evt.target.closest('.option-selector').querySelector('.option-sub-text');
        subTextContainer.classList.remove('hidden');
        subTextContainer.innerHTML = `<span class="small">${evt.target.dataset.subtext}</span>`;
      }
    }

    handleCombineListingClick(evt){
      // console.log(evt);
      this.currentTab = evt.target.closest('.tab-content') ? evt.target.closest('.tab-content').id : null;
      this.currentSelection = evt.target.closest('.tab-content') ? [...evt.target.closest('.tab-content').querySelectorAll('.option-selector')]
        .map(selector => {
          const checkedInput = selector.querySelector('input:checked');
          return checkedInput ? checkedInput.value : null;
        }) : [...evt.target.closest('.variant-picker-curated-packs').querySelectorAll('.option-selector')]
        .map(selector => {
          const checkedInput = selector.querySelector('input:checked');
          return checkedInput ? checkedInput.value : null;
        });
      // console.log(this.currentSelection, this.currentTab);
      const qty = this.section.querySelector('.quantity-submit-row [name="quantity"]') ? this.section.querySelector('.quantity-submit-row [name="quantity"]').value : 0;
      document.querySelectorAll(`.section-main-product`).forEach(element => {
        if(evt.target.dataset.productHandle != element.dataset.product){
          element.classList.add('hidden-soft');
        }else{
          /* change current url */
          const url = new URL(window.location.href);
          url.pathname = url.pathname.replace(
            /(\/products\/)[^/]+/,
            `$1${element.dataset.product}`
          );

          window.history.replaceState({}, '', url.href);

          if(element.querySelector('variant-picker-bundle')){
            element.querySelector('variant-picker-bundle').querySelector(`[data-for="${this.currentTab}"]`).dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
            element.querySelector('variant-picker-bundle').querySelectorAll('.option-selector--combine-listing').forEach(el => {
              if(el.querySelector(`input[value="${evt.target.value}"]`)){
                el.querySelector(`input[value="${evt.target.value}"]`).checked = true;
                element.querySelector('.option-sub-text').innerHTML = `<span class="small">${el.querySelector(`input[value="${evt.target.value}"]`).dataset.subtext}</span>`;
              }
            })
            element.querySelector('variant-picker-bundle').querySelector(`#${this.currentTab}`).querySelectorAll('.option-selector').forEach((el, i) => {
              const val = this.currentSelection[i];
              if(i == 0){
                el.querySelector(`input[value="${evt.target.value}"]`).checked = true;
                return;
              }
              if(el.querySelector(`input[value="${CSS.escape(val)}"]`)){
                const input = el.querySelector(`input[value="${CSS.escape(val)}"]`)
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
              }
              return;
            });
          }
          if(element.querySelector('variant-picker-curated-packs')){
            const lengthStatus = this.section.querySelector('.option-selector[data-option="Length"] .js-option-text').innerText.includes('Switch') ? true : false;
            
            if(element.querySelector('.quantity-submit-row custom-select')){
              element.querySelector('.quantity-submit-row custom-select').selectOption(element.querySelector(`.quantity-submit-row custom-select [data-value="${qty}"]`));
              element.querySelector('.quantity-submit-row [name="quantity"]').value = qty;
              element.querySelector('.quantity-submit-row [name="quantity"]').dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
            }
            element.querySelector('variant-picker-curated-packs').querySelectorAll('.option-selector--combine-listing').forEach(el => {
              if(el.querySelector(`input[value="${evt.target.value}"]`)){
                el.querySelector(`input[value="${evt.target.value}"]`).checked = true;
                element.querySelector('.option-sub-text').innerHTML = `<span class="small">${el.querySelector(`input[value="${evt.target.value}"]`).dataset.subtext}</span>`;
              }
            })
            element.querySelector('variant-picker-curated-packs').querySelectorAll('.option-selector').forEach((el, i) => {
              const val = this.currentSelection[i];
              if(i == 0){
                el.querySelector(`input[value="${evt.target.value}"]`).checked = true;
                return;
              }
              // console.log(lengthStatus);
              if(el.querySelector(`input[value="${CSS.escape(val)}"]`)){
                if(el.dataset.option == 'Length'){
                  if(lengthStatus == true){
                    return;
                  }
                  if(el.querySelector('.switch-tall')){
                    el.querySelector('.switch-tall').classList.add('hidden');
                  }
                  el.querySelector('.option-selector__btns').classList.remove('hidden');
                }
                const input = el.querySelector(`input[value="${CSS.escape(val)}"]`)
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
              }
              return;
            });
          }
          if(window.innerWidth < 768){
            element.querySelectorAll('carousel-slider').forEach(carousel => {
              carousel.refresh();
            });
          }
          if(Object.keys(apConfig).length > 0 && !element.querySelector('.afterpay-paragraph')){
            apConfig.priceSelector = `#${element.id} ${apConfig.priceSelector}`;
            new presentAfterpay(apConfig).init();
          }
          element.classList.remove('hidden-soft');
        }
      });
      if(evt.target.closest('.tab-content')){
      }
    }

    async getOtherHTML(handle){
      try {
        const url = `/products/${handle}`;
        const baseUrl = window.location.origin;
        const htmlResponse = await this.renderSection(`${url}`);
        const innerHTML = htmlResponse;
        const htmlDoc = new DOMParser().parseFromString(innerHTML, 'text/html');
        const section = htmlDoc;

        if (!section) return null;
        return section;
      } catch (error) {
        console.error(`Error loading product :`, error);
      }
    }

    updateBIS(){
      if(this.variant){
        if(!this.variant.available){
          this.section.querySelector('.buy-buttons-row').classList.add('hidden');
          if(this.section.querySelector('product-ship-message'))
            this.section.querySelector('product-ship-message').classList.add('hidden');
          this.section.querySelector('.notify-back-in-stock-container').classList.remove('hidden');
        }else{
          this.section.querySelector('.buy-buttons-row').classList.remove('hidden');
          if(this.section.querySelector('product-ship-message'))
            this.section.querySelector('product-ship-message').classList.remove('hidden');
          if(this.section.querySelector('.notify-back-in-stock-container'))
            this.section.querySelector('.notify-back-in-stock-container').classList.add('hidden');
        }
      }
    }

    /**
     * Updates the "Add to Cart" button label and status.
     */
    updateAddToCartButton() { 
      if (!this.productForm) return;
      
      if (this.selectedOptions.indexOf(null) > -1) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.classList.remove('is-error');
      this.addBtn.setAttribute('aria-disabled', !variantAvailable);

      if(this.addBtn.querySelector('.add-to-cart-text')){
        this.addBtn.querySelector('.add-to-cart-text').textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
        return;
      }
      
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      // el.disabled = !available;
      el.disabled = false;
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability(evt) {
      if (this.dataset.availability === 'off') return;
      const { availabilityMode } = this.dataset; // 'down' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMode === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""]):not(.custom-select__option-exclude)');
          
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            if(option.closest('.option-selector').dataset.option != 'Color'){
              VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
            }
          });
        });
        if(this.optionSelectors.length > 1){
          this.updateColorAvailability(evt);
        }
      }
    }

    updateColorAvailability(evt){
      let assignFirst = false;
      let optionIndex = 0;

      const isOptionSelectorEvent = evt?.target?.closest('.option-selector');
      if (isOptionSelectorEvent && +isOptionSelectorEvent.dataset.optionIndex > 1) {
        assignFirst = true;
        optionIndex = +isOptionSelectorEvent.dataset.optionIndex - 1;
      }

      if (this.firstTime === true) {
        assignFirst = true;
        optionIndex = 1;
      }

      if (!assignFirst) return;

      const matchedVariants = this.data.variants.filter(v => {
        const opts = this.selectedOptions;
          opts.forEach((o, i) => {
            if (o == null){
              opts[i] = this.data.variants[0][`option${i+1}`]
            }
          })

        if (opts.length === 3) {
          return opts[2] != null
            ? opts[1] === v.options[1] && opts[2] === v.options[2]
            : opts[1] === v.options[1];
        }
        if (opts.length === 2) {
          return opts[1] === v.options[1];
        }
        return false;
      });
      // console.log(matchedVariants);
      
      this.optionSelectors.forEach((selector, selectorIndex) => {
        if (optionIndex <= selectorIndex) return;

        const isDropdown = selector.dataset.selectorType === 'dropdown';
        const options = selector.querySelectorAll('.js-option:not([data-value=""]):not(.custom-select__option-exclude)');

        options.forEach((option, index) => {
          const optionValue = isDropdown ? option.dataset.value : option.value;

          const isAvailable = matchedVariants.some(v => v.options[selectorIndex] === optionValue && v.available);
          if(selectorIndex === 0){
            if(option.closest('.opt-btn-container')){
              option.closest('.opt-btn-container').querySelector('.custom-select__btn').disabled = !isAvailable;
            }
            VariantPicker.updateOptionAvailability(option, true, isAvailable);
          }
        });
      });
    }

    updateFinalSale(){
      if(!this.querySelector('.final-sale-swatches')){
        return;
      }
      this.finalSaleContainer = this.querySelector('.final-sale-swatches');
      this.finalSaleColors = this.querySelectorAll('.final-sale-swatch');
      const btnsContainer = this.finalSaleContainer.querySelector('.option-selector__btns');
      if(this.finalSaleColors && this.finalSaleColors.length > 0){
        this.finalSaleContainer.classList.remove('hidden');
        this.finalSaleColors.forEach(swatch => {
          if(btnsContainer.querySelector('.swatch-slider') != undefined){
            const swatchDiv = swatch.closest('.swatch-wrapper');
            swatch.classList.remove('hidden');
            btnsContainer.querySelector('.swatch-slider').appendChild(swatchDiv);
          }else{
            swatch.classList.remove('hidden');
            btnsContainer.appendChild(swatch);
          }
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default') ? '' : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the colour option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;
      if (selector.classList.contains('option-selector--custom')) return;

      const otherOption = selector.querySelector('.js-option-text');
      let optionValue = evt.target.nextElementSibling.querySelector('.js-value').textContent;

      if(otherOption){
        otherOption.textContent = optionValue;
      }

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      if(evt.target.classList.contains('final-sale-swatch')){
        colorText.textContent = '';
        selector.querySelector('.final-sale-swatches .js-color-text').textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
        return;
      }else{
        if(evt.target.closest('.option-selector').dataset.option == 'Color' && selector.querySelector('.final-sale-swatches .js-color-text')){
          selector.querySelector('.final-sale-swatches .js-color-text').textContent = '';
        }
      }
      
      if(evt.target.tagName == 'SELECT'){
        // colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
      }else{
        colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice(container) {
      this.price = this.price || this.section.querySelector('.product-info__price .price');
      this.discountLabel = this.discountLabel || this.section.querySelector(`.product-info__price .product-label-container`);
      if(container){
        this.price = this.section.querySelector(`${container} .product-info__price .price`);
        this.discountLabel = this.section.querySelector(`${container} .product-info__price .product-label-container`);
      }
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {

        variant = this.data.variants.find(v => v.available);
        /* remove code for lowest price replace it with default first available variant. */
        // variant = this.data.variants[0];
        // for (let i = 1; i < this.data.variants.length; i += 1) {
        //   if (this.data.variants[i].price < variant.price) variant = this.data.variants[i];
        // }
      }

      if(!this.getSelectedVariant() || this.selectedOptions.indexOf(null) > -1){
        return;
      }

      if (variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        if(this.price.querySelector('.extra-price')){
          this.price.querySelector('.extra-price').remove();
        }

        let memberDiscountPrice= variant.price - (variant.price*10/100);
        if(this.section.querySelector('.product-membership-widget')){
          if(this.section.querySelector('.product-membership-widget').classList.contains('existing-membership')){
            memberDiscountPrice= variant.price*20/100;
            if(this.section.querySelector(`.single-product-membership-widget`).classList.contains('hidden')){
              this.section.querySelector(`.pack-product-membership-widget .product-member-price`).innerHTML = Shopify.formatMoney(memberDiscountPrice, window.theme.settings.moneyWithoutCurrencyFormat);
            }else{
              this.section.querySelector(`.single-product-membership-widget .product-member-price`).innerHTML = Shopify.formatMoney(memberDiscountPrice, window.theme.settings.moneyWithoutCurrencyFormat);
            }
          }else{
            if(this.section.querySelector(`.single-product-membership-widget`) && !this.section.querySelector(`.single-product-membership-widget`).classList.contains('hidden')){
              this.section.querySelector(`.single-product-membership-widget .product-member-price`).innerHTML = Shopify.formatMoney(memberDiscountPrice, window.theme.settings.moneyWithoutCurrencyFormat);
            }
            if(this.section.querySelector(`.pack-product-membership-widget`) && !this.section.querySelector(`.pack-product-membership-widget`).classList.contains('hidden')){
              memberDiscountPrice= variant.price*20/100;
              this.section.querySelector(`.pack-product-membership-widget .product-member-price`).innerHTML = Shopify.formatMoney(memberDiscountPrice, window.theme.settings.moneyWithoutCurrencyFormat);
            }
          }
        }

        // Update current price and original price if on sale.
        // priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
        if(document.querySelector('body').classList.contains('template-subscription-product')){
          priceCurrentEl.innerHTML = `${this.data.formatted[variant.id].price}/Month `;
        }else{
          priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
        }
        if (priceWasEl) priceWasEl.innerHTML = this.data.formatted[variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = variant.unit_price_measurement.reference_value;
          const unit = variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          unitPriceEl.hidden = false;
        } else if (unitPriceEl) {
          unitPriceEl.hidden = true;
        }

        this.price.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
        this.price.classList.toggle('price--sold-out', !variant.available && !this.preSelection);

        if(this.discountLabel){
          if(this.discountLabel.querySelector('.product-label--sale span')){
            if(variant.compare_at_price > variant.price){
              const cal1 = 1.0*(variant.price/variant.compare_at_price);
              const cal2 = (1.0 - cal1);
              const discountAmount = (1.0 - cal1)*100;
              this.discountLabel.querySelector('.product-label--sale span').classList.remove('hidden');
              this.discountLabel.querySelector('.product-label--sale span').innerText = `${Math.round(discountAmount)}% Off`;
            }else{
              this.discountLabel.querySelector('.product-label--sale span').classList.add('hidden');
            }
          }
        }
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }

      if(!container){
        this.updatePrice('.desktop-price-container');
        this.updatePrice('.price-container:not(.desktop-price-container)');
      }
    }

    updateQuantity(evt){
      console.log(evt);
      this.quantity = parseInt(evt.detail.quantity);
      const totalPrice = this.variant.price * this.quantity;
      // A variant with no compare-at price gives null * quantity = 0, which zeroed out
      // the pack price. Fall back to the variant price, matching the behaviour in
      // VariantPickerCuratedPacks (compare_at_price > 0 ? compare_at_price : price).
      const hasCompareAt = this.variant.compare_at_price > this.variant.price;
      const compareBase = hasCompareAt ? this.variant.compare_at_price : this.variant.price;
      const totalComparePrice = compareBase * this.quantity;
      console.log(totalPrice, totalComparePrice, this.quantity);

      const priceContainers = this.section.querySelectorAll('.price-container');
      priceContainers.forEach(container => {
        const discountDetails = this.section.querySelector('#packDiscountJSON[type="application/json"]') || null;
        let discountData = null;
        if(discountDetails){
          discountData = JSON.parse(discountDetails.textContent);
        }
        console.log(discountData);
        const packPriceContainer = container.querySelector('.pack-pricing');
        const singlePriceContainer = container.querySelector('.single-price');
        if(discountData.length > 0 && this.quantity > 1){
          const discount = discountData
            .filter(d => parseInt(d.qty) <= this.quantity)
            .sort((a, b) => parseInt(b.qty) - parseInt(a.qty))[0];
          console.log(discount);
          if(discount){
            const discountPercentage = parseFloat(discount.discount) / 100;
            let discountedAmount = totalComparePrice * (1 - discountPercentage);
            let ogPrice = discountedAmount < totalPrice ? discountedAmount : totalPrice;
            let ogComPrice = totalComparePrice;
            packPriceContainer.classList.remove('hidden');
            singlePriceContainer.classList.add('hidden');
            packPriceContainer.querySelector('.price__current').innerHTML = Shopify.formatMoney(ogPrice, window.theme.settings.moneyWithoutCurrencyFormat);;
            packPriceContainer.querySelector('.price__was').innerHTML = Shopify.formatMoney(totalComparePrice, window.theme.settings.moneyWithoutCurrencyFormat);
            packPriceContainer.querySelector('.product-label--sale span').innerText = `${Math.round(parseFloat(discount.discount))}% Off`;
          }
        }else{
          packPriceContainer.classList.add('hidden');
          singlePriceContainer.classList.remove('hidden');
          singlePriceContainer.querySelector('.price__current').innerHTML = Shopify.formatMoney(totalPrice, window.theme.settings.moneyWithoutCurrencyFormat);;
          singlePriceContainer.querySelector('.price__was').innerHTML = hasCompareAt ? Shopify.formatMoney(totalComparePrice, window.theme.settings.moneyWithoutCurrencyFormat) : '';
        }

        // pack-pricing

        // if(this.quantity > 1){
        //   container.querySelector('.single-price').classList.add('hidden');
        //   container.querySelector('.pack-pricing').classList.remove('hidden');
        //   container.querySelector('.pack-pricing .price__current').innerHTML = Shopify.formatMoney(totalPrice, window.theme.settings.moneyWithoutCurrencyFormat);
        //   container.querySelector('.pack-pricing .price__was').innerHTML = Shopify.formatMoney(totalComparePrice, window.theme.settings.moneyWithoutCurrencyFormat);
        // }else{
        //   container.querySelector('.single-price').classList.remove('hidden');
        //   container.querySelector('.pack-pricing').classList.add('hidden');
        // }
      });

      
      // this.updatePrice();
      
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcode = this.barcode || this.section.querySelector('.product-barcode__value');
      if (!this.barcode) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
      this.barcode.parentNode.hidden = !barcodeAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      const url = this.variant ? `${this.dataset.url}?variant=${this.variant.id}` : this.dataset.url;
      window.history.replaceState({ }, '', url);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms = this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('[name="id"]');
        input.value = this.variant ? this.variant.id : '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the variant data for a product.
     * @returns {?object}
     */
    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get the selected values from a list of variant options.
     * @returns {Array} Array of selected option values, value is null if not selected.
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
          selectedOptions.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      return this.data.variants.find(
        (v) => v.options.every((val, index) => val === this.selectedOptions[index])
      );
    }

    /**
     * Apply search parameters.
     */
    applySearchParams() {
      const searchParams = new URLSearchParams(window.location.search);

      Array.from(searchParams.keys()).forEach((key) => {
        const value = searchParams.get(key);
        const optionSelectors = Array.from(this.optionSelectors);
        const matchingOptionSelector = optionSelectors.find((x) => x.dataset.option === key);
        if (!matchingOptionSelector) return;

        if (matchingOptionSelector.dataset.selectorType === 'dropdown') {
          const colorOptionDropdown = matchingOptionSelector.querySelector(`.custom-select__option[data-value="${value}"]`);
          if (colorOptionDropdown) {
            const customSelect = colorOptionDropdown.closest('custom-select');
            customSelect.selectOption(colorOptionDropdown);
          }
        } else {
          const matchingInput = matchingOptionSelector.querySelector(`input[value="${value}"]`);
          if (matchingInput) {
            const matchingOptionValue = matchingOptionSelector.querySelector('.option-selector__label-value');
            if (matchingOptionValue) {
              matchingOptionSelector.querySelector('.option-selector__label-value').textContent = value;
            }
            matchingInput.checked = true;
            matchingInput.dispatchEvent(
              new CustomEvent('change', { bubbles: true, cancelable: false })
            );
          }
        }
      });
    }
  }

  customElements.define('variant-picker', VariantPicker);

  if (!customElements.get('variant-picker-curated-packs')) {
    class VariantPickerCuratedPacks extends VariantPicker {
      constructor() {
        super();
        this.section = this.closest('.js-product');
        this.mainVariantContainer = this.closest('variant-picker-curated-packs');
        this.variantData = super.getVariantData();
        this.packData = this.getPackData();
        this.curatedPackDiscountJson = this.getCuratedPackDiscountData();
        this.singleDiscountJson = this.getSinglesDiscountData();

        this.packTypeInput = this.productForm.querySelector('[name="__pack-type"]');

        this.packColorSelector = this.querySelector('.option-selector[data-option="Packs Color"]');
        this.colorSelector = this.querySelector('.option-selector[data-option="Color"]');

        this.selectedPackQuantity = null;
        this.selectedPackQuantityData = null;
        this.selectedPack = null;
        this.packType = 'single';

        this.querySelectorAll('.option-selector').forEach(opt => {
          // console.log(this.selectedPack, this.selectedPackQuantity);
          if(opt.dataset.option == 'Packs Color'){
            opt.classList.add('hidden');
            opt.querySelector('.option-selector__btns').insertAdjacentHTML('beforeend', `<span class="show-more-btn hidden">+</span>`);
            const showMoreBtn = opt.querySelector('.show-more-btn');
            showMoreBtn.addEventListener('click', (e) => {
              opt.querySelector('.packs-colors-picker').classList.add('packs-color-expanded');
              opt.querySelectorAll('.pack-color-wrapper').forEach(el => el.classList.remove('hidden-by-limit'));
            });
            // console.log(this.selectedPack);
            // opt.querySelector(`input[data-pack-value="${this.selectedPack.id}"]`).checked = true;
            // opt.querySelector(`input[data-pack-value="${this.selectedPack.id}"]`).dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
          }
          if(opt.dataset.option == 'Packs Quantity'){
            const discountMessage = this.dataset.singleDiscountMessage;
            let qtyInput = 'Singles';
            if(this.selectedPackQuantity){
              qtyInput = this.selectedPackQuantity;
            }
            opt.querySelector('.label').insertAdjacentHTML('beforeend', `<span data-add-more-msg="${discountMessage}" class="single-discount"></span><span class="pack-each-price"></span>`);
            if(this.section.querySelector(`.single-product-membership-widget`)){
              this.section.querySelector(`.single-product-membership-widget`).classList.remove('hidden');
            }

            if(this.singleDiscountJson != null){
              const discounts = this.singleDiscountJson.discounts;
              const firstDiscount = discounts[0];
              const lastDiscount = discounts[discounts.length - 1];

              const discountFinalMessage = discountMessage.replace('QTY', firstDiscount.pack).replace('DISCOUNT', lastDiscount.display_discount);
              opt.querySelector('.label .single-discount').innerText = discountFinalMessage;
              opt.querySelector('.label .single-discount').dataset.selectMsg = discountFinalMessage;
              // opt.querySelector('.label .single-discount').innerText = `Buy ${discount.pack}+ for discount (up to ${discount.display_discount}% off)`;
              // opt.querySelector('.label .single-discount').dataset.selectMsg = `Buy ${discount.pack}+ for discount (up to ${discount.display_discount}% off)`;
            }

            opt.querySelector(`input[value="${qtyInput}"]`).checked = true;
            opt.querySelector(`input[value="${qtyInput}"]`).dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
          }
          if(opt.dataset.option == 'Length'){
            if(this.closest('.modal-cart-edit-popup-container') || opt.querySelectorAll('input')[0]?.value != 'Reg'){
              opt.querySelector('.option-selector__btns').classList.remove('hidden');
              return;
            }
            opt.querySelector('.option-selector__btns').classList.add('hidden');
            opt.querySelectorAll('.option-selector__btns input').forEach(el => {
              const label = el.nextElementSibling;
              if (!label || label.tagName !== 'LABEL') return;

              const wrapper = document.createElement('div');
              el.before(wrapper);
              wrapper.append(el, label);

              if(el.dataset.subtext != undefined || el.dataset.subtext != ''){
                const span = document.createElement('span');
                span.classList.add('opt-sub-text')
                span.textContent = el.dataset.subtext;
                wrapper.append(span);
              }
            });
            opt.querySelector('.js-option-text').innerHTML = `<strong>Regular</strong> 6’3” and above? <a class="switch-tall switch-to">Switch to Tall.</a>`;
            const link = opt.querySelector('.switch-tall');

            link.addEventListener('click', (e) => {
              e.preventDefault();
              opt.querySelector('.option-selector__btns').classList.remove('hidden');
              opt.querySelector('.option-selector__btns').querySelector('input[value="Tall"]').checked = true;
              opt.querySelector('.option-selector__btns').querySelector('input[value="Tall"]').dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
            });
          }
        });

        if (!this.closest('product-form')?.classList.contains('cart-edit-popup')) {
          this.handleURL();
        }

        super.updateSelectedOptText();
        // this.addEventListener('change', super.handleVariantChange.bind(this));
        this.addEventListener('change', this.handleCuratedVariantChange.bind(this));
        if (!this.closest('product-form')?.classList.contains('cart-edit-popup')) {
          this.selectOptions(); 
        }
        this.closest('.js-product').addEventListener('on:quantity:change', this.updateQuantity.bind(this));
        // this.querySelector('.option-selector[data-option="Packs Quantity"] .js-option-text').innerText = '1';
        if(!this.closest('.modal-cart-edit-popup-container')){
          this.selectOptions();
        }
        this.runABTest();
      }

      handleCuratedVariantChange(evt){
        // super.handleVariantChange(evt);
        this.updateAddButton();
        if(this.packType == 'single' || evt.target.value == 'Singles'){
          this.packType = 'single'
          // console.log(evt);
          super.handleVariantChange(evt);
          super.updateVariantInput();
          // super.updateAddToCartButton();
          super.updateAvailability(evt);
          super.updatePrice();
          super.updateSku();
          super.updateBIS();

          this.selectedPackQuantity = null;
          this.selectedPackQuantityData = null;
          this.selectedPack = null;
          this.updateURL();
        }
        const option = evt.target.closest('.option-selector').dataset.option;
        super.updateSelectedOptText(evt);

        this.handleURL();

        if(option == 'Packs Quantity'){
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.eventParameter = {};
          dataLayer.push({
            event: 'pdp_click',
            eventParameter:{
              event_trigger_type: 'pack_tier_click',
              event_trigger_value: evt.target.value,
              pack_size: evt.target.value == 'Singles' ? 1 : evt.target.value,
              previous_pack_size: this.selectedPackQuantity
            },
            custom_event_label: 'pack_tier_click',
            custom_event_value: evt.target.value
          });
        }
        if(option == 'Length'){
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.eventParameter = {};
          dataLayer.push({
            event: 'pdp_click',
            eventParameter:{
              event_trigger_type: 'switch_to_tall_click',
              event_trigger_value: evt.target.value,
              length: evt.target.value
            },
            custom_event_label: 'switch_to_tall_click',
            custom_event_value: evt.target.value
          });
        }
        if(option == 'Packs Color'){
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.eventParameter = {};
          dataLayer.push({
            event: 'pdp_click',
            eventParameter:{
              event_trigger_type: 'curated_pack_click',
              event_trigger_value: evt.target.value,
              pack_size: this.selectedPackQuantity,
              pack_id: evt.target.dataset.packValue,
              pack_position: evt.target.dataset.packPosition,
              is_top_seller: evt.target.dataset.topSeller
            },
            custom_event_label: 'curated_pack_click',
            custom_event_value: evt.target.value
          });
        }

        if(option == 'Packs Quantity'){
          this.packTypeInput.value = evt.target.value == 'Singles' ? 'single' : 'fixed';
          this.packType = evt.target.value == 'Singles' ? 'single' : 'fixed';

          // if(evt.target.value == 'Singles'){
          //   evt.target.closest('.option-selector').querySelector('.js-option-text').innerText = '1'
          // }

          const title = this.section.querySelector('.product-title').dataset.productTitle;
          this.section.querySelector('.product-title').innerText = evt.target.value == 'Singles' ? `${title}` : `${title} (${evt.target.value}-Pack)`;

          if(this.section.querySelectorAll(`.product-membership-widget`).length > 0){
            this.section.querySelectorAll(`.product-membership-widget`).forEach(p => p.classList.add('hidden'));
            if(evt.target.value == 'Singles'){
              if(this.section.querySelector(`.single-product-membership-widget`)){
                this.section.querySelector(`.single-product-membership-widget`).classList.remove('hidden');
              }
            }else{
              if(this.section.querySelector(`.pack-product-membership-widget`)){
                this.section.querySelector(`.pack-product-membership-widget`).classList.remove('hidden');
              }
            }
          }

          if(evt.target.value == 'Singles'){
            this.colorSelector.classList.remove('hidden');
            this.packColorSelector.classList.add('hidden');
            if (this.section.querySelector('#quantity-selector') != undefined) 
              this.section.querySelector('#quantity-selector').classList.remove('hidden');
          }else{
            this.colorSelector.classList.add('hidden');
            this.packColorSelector.classList.remove('hidden');
            if (this.section.querySelector('#quantity-selector') != undefined) 
              this.section.querySelector('#quantity-selector').classList.add('hidden');

            this.selectedPackQuantity = evt.target.value;
            this.updateURL();
            this.filterPacks(evt);
            // if(!this.closest('.shopify-section').classList.contains('hidden-soft')){
            // }
          }
        }
        if(option == 'Packs Color'){
          const value = evt.target.dataset.packValue;
          this.selectedPack = this.packData.packs.find(pack => pack.id == value);
          // this.updateOptions();
          this.updateURL();
        }
        if(this.packType != 'single'){
          this.updateOptions(evt);
        }
        this.updatePriceAndDiscount();
      }

      runABTest(){
      }

      renderSection = async (sectionId) => {
        try {
          const response = await fetch(sectionId, {
            method: 'get',
          })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
          })
          .then((response) => {
            return response;
          })
          .catch((error) => {
            console.warn(error);
          });

          return response;
        } catch (error) {
          console.error(error);
        }
      };

      updateAddButton(){
        this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
        this.addBtn.classList.remove('is-error')
        this.addBtn.setAttribute('aria-disabled', false);
      }

      selectOptions(){
        setTimeout(() => {
          if(this.selectedPackQuantity && this.selectedPackQuantity != 'Singles'){
            this.querySelector(`.packs-quantity-picker input[value="${this.selectedPackQuantity}"]`).checked = true;
            this.querySelector(`.packs-quantity-picker input[value="${this.selectedPackQuantity}"]`).dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
            // this.handleCuratedVariantChange(this.querySelector(`.packs-quantity-picker input[value="${this.selectedPackQuantity}"]`));
          }
          if(this.selectedPack){
            this.querySelector(`.packs-colors-picker input[data-pack-value="${this.selectedPack.id}"]`).checked = true;
            this.querySelector(`.packs-colors-picker input[data-pack-value="${this.selectedPack.id}"]`).dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
            // this.handleCuratedVariantChange(this.querySelector(`.packs-colors-picker input[data-pack-value="${this.selectedPack.id}"]`));
          }
        }, 300);
      }

      updateURL() {
        const urlObj = new URL(window.location.href);
        const params = urlObj.searchParams;

        // Add or update params
        if (this.selectedPackQuantity) {
          params.set('pack', this.selectedPackQuantity);
        } else {
          params.delete('pack');
        }

        if (this.selectedPackQuantity && this.selectedPack) {
          params.set('pack-id', this.selectedPack.id);
        } else {
          params.delete('pack-id');
        }

        const containingSection = this.closest('.shopify-section');
        if(!containingSection || containingSection.classList.contains('hidden-soft')){
          return;
        }

        // Build final URL
        const newURL =
          urlObj.pathname +
          (params.toString() ? `?${params.toString()}` : '') +
          urlObj.hash;

        // Update without reload
        window.history.replaceState({}, '', newURL);
      }

      handleURL(){
        this.currentURLParmas = [];
        const urlObj = new URL(window.location.href);
        const params = urlObj.searchParams;

        const pack = params.get('pack');
        const packId = params.get('pack-id');
        const color = params.get('color');
        if(color){
          this.querySelector(`[data-option="Color"] input[value=${color}]`).checked = true;
          this.querySelector(`[data-option="Color"] input[value=${color}]`).dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
        }
        if(pack){
          this.packType = 'fixed';
          this.selectedPackQuantity = Number(pack);
          this.selectQuantityPacksData();
        }
        if(packId){
          this.selectedPack = this.packData.packs.find(pack => pack.id == packId);
        }
      }

      updatePriceAndDiscount(){
        this.priceContainers = this.section.querySelectorAll('.price-container');
        // console.log(this.totalQuantity);
        if(this.packType == 'single'){
          this.querySelector('.single-discount').classList.remove('hidden');
          this.querySelector('.pack-each-price').classList.add('hidden');
          this.section.querySelectorAll('.single-price').forEach(el => el.classList.remove('hidden'));
          this.section.querySelectorAll('.curated-pack-pricing').forEach(el => el.classList.add('hidden'));

          let variant = super.getSelectedVariant();
          if(!variant){
            variant = this.variantData.variants[0];
          }
          if(variant){
            // this.totalQuantity;
            this.validateQtyBuild = true;
            this.udpateDiscountMessage();
            if(this.totalQuantity > 1){
              this.section.querySelectorAll('.pack-pricing').forEach(el => el.classList.remove('hidden'));
              this.section.querySelectorAll('.single-price').forEach(el => el.classList.add('hidden'));
              if(this.section.querySelector(`.pack-product-membership-widget`)){
                this.section.querySelector(`.pack-product-membership-widget`).classList.remove('hidden');
              }
              if(this.section.querySelector(`.single-product-membership-widget`)){
                this.section.querySelector(`.single-product-membership-widget`).classList.add('hidden');
              }
            }else{
              this.section.querySelectorAll('.single-price').forEach(el => el.classList.remove('hidden'));
              this.section.querySelectorAll('.pack-pricing').forEach(el => el.classList.add('hidden'));
              if(this.section.querySelector(`.pack-product-membership-widget`)){
                this.section.querySelector(`.pack-product-membership-widget`).classList.add('hidden');
              }
              if(this.section.querySelector(`.single-product-membership-widget`)){
                this.section.querySelector(`.single-product-membership-widget`).classList.remove('hidden');
              }
            }

            if(!this.singleDiscountJson){
              return;
            }

            const basePrice = this.variantData.variants[0].compare_at_price > 0 ? this.variantData.variants[0].compare_at_price : this.variantData.variants[0].price; // price in cents
            const originalPrice = this.variantData.variants[0].price;
            const pricingTiers = [...this.singleDiscountJson.discounts].sort((a, b) => b.pack - a.pack); // Descending
            const sortedPricingTiers = [...this.singleDiscountJson.discounts].sort((a, b) => a.pack - b.pack); // Descending

            this.priceContainers.forEach(el => {
              const element = el.querySelector('.pack-pricing');
              let remainingQty = this.totalQuantity;
              let newTotal = 0;
              let currentTier = null;
              let discountPercentage = 0;

              // Apply discount tiers
              for (const tier of pricingTiers) {
                while (remainingQty >= tier.pack) {
                  const packTotal = basePrice * tier.pack;
                  currentTier = tier;
                  const discountAmount = (packTotal * tier.discount) / 100;
                  newTotal += packTotal - discountAmount;
                  remainingQty -= tier.pack;
                }
              }

              // Remaining items without discount
              if (remainingQty > 0) {
                newTotal += originalPrice * remainingQty;
              }

              const compareAtTotal = basePrice * this.totalQuantity;
              const pricePer = newTotal / this.totalQuantity;
              // const pricePerFormat = el.querySelector('.price-per--item').dataset.msg;
              let compareQty = 0;
              if(!this.validateQtyBuild){
                compareQty = 0;
              }
              discountPercentage = ((compareAtTotal - newTotal) / compareAtTotal) * 100;

              if (this.totalQuantity > compareQty || newTotal < compareAtTotal) {
                if(compareAtTotal == newTotal){
                  element.classList.remove('price--on-sale');
                  element.querySelector('.price__current').innerHTML = Shopify.formatMoney(newTotal, window.theme.settings.moneyWithoutCurrencyFormat);
                  element.querySelector('.price__was').innerHTML = '';
                  element.querySelector('.product-label--sale span').classList.add('hidden');
                }else{
                  element.classList.add('price--on-sale');
                  element.querySelector('.price__current').innerHTML = Shopify.formatMoney(newTotal, window.theme.settings.moneyWithoutCurrencyFormat);
                  element.querySelector('.price__was').innerHTML = Shopify.formatMoney(compareAtTotal, window.theme.settings.moneyWithoutCurrencyFormat);
                  element.querySelector('.product-label--sale span').classList.remove('hidden');
                  element.querySelector('.product-label--sale span').innerText = `${Math.round(discountPercentage)}% Off`;
                }
                // element.querySelector('.price-per--item').innerHTML = pricePerFormat.replace('MONEY', Shopify.formatMoney(pricePer, window.theme.settings.moneyWithoutCurrencyFormat));

                const currentPrice = newTotal;
                const newDiscountedPrice = Shopify.formatMoney(currentPrice*20/100, window.theme.settings.moneyWithoutCurrencyFormat);
                if(this.section.querySelector(`.pack-product-membership-widget .product-member-price`)){
                  this.section.querySelector(`.pack-product-membership-widget .product-member-price`).innerHTML = newDiscountedPrice;
                }
              } else {
                if(this.validateQtyBuild){
                  // Reset to default
                  ['.price__current', '.price__was'].forEach(selector => {
                    const elDefault = element.querySelector(selector);
                    elDefault.innerHTML = elDefault.dataset.default;
                  });
                  const totalPrice = basePrice - (basePrice*sortedPricingTiers[0].discount/100);
                  const totalPackPrice = sortedPricingTiers[0].pack*totalPrice;
                  const newDiscountedPrice = Shopify.formatMoney(totalPackPrice*20/100, window.theme.settings.moneyWithoutCurrencyFormat);
                  if(this.section.querySelector(`.pack-product-membership-widget .product-member-price`)){
                    this.section.querySelector(`.pack-product-membership-widget .product-member-price`).innerHTML = newDiscountedPrice;
                  }
                }else{
                  element.querySelector('.price__current').innerHTML = Shopify.formatMoney(originalPrice, window.theme.settings.moneyWithoutCurrencyFormat);
                  element.querySelector('.price__was').innerHTML = Shopify.formatMoney(basePrice, window.theme.settings.moneyWithoutCurrencyFormat);
                  // element.querySelector('.price-per--item').innerHTML = ``;
                }
              }
            });
          }
          this.productForm.querySelector('.pack-inputs').innerHTML = ``;
        }else{
          if(this.curatedPackDiscountJson != null){
            if(!this.selectedPack){
              return;
            }
            const { totalPrice, totalQty } = this.selectedVariants.reduce((acc, variant) => {
              const qty = variant.qty || 0;
              let price = variant.price || 0;
              if(variant.compare_at_price > 0 && variant.compare_at_price > variant.price){
                price = variant.compare_at_price;
              }
              acc.totalQty += qty;
              acc.totalPrice += qty * price;
              return acc;
            }, { totalPrice: 0, totalQty: 0 });
            const discountPack = this.curatedPackDiscountJson.discounts.find(dis => dis.pack == this.selectedPack.pack);
            let discount = discountPack.discount;
            if(this.selectedPack != null && this.selectedPack.discount != '' && this.selectedPack.discount != '0' && parseFloat(this.selectedPack.discount) > 0){
              discount = this.selectedPack.discount;
            }
            const discountedTotal = totalPrice * parseFloat(discount) / 100;
            const remainingTotal = totalPrice - discountedTotal;
            const eachDiscountedItem = remainingTotal / discountPack.pack;

            if(this.section.querySelector(`.pack-product-membership-widget .product-member-price`)){
              const currentPrice = remainingTotal;
              const newDiscountedPrice = Shopify.formatMoney(currentPrice*20/100, window.theme.settings.moneyWithoutCurrencyFormat);
              this.section.querySelector(`.pack-product-membership-widget .product-member-price`).innerHTML = newDiscountedPrice;
            }
            
            this.querySelector('.pack-each-price').innerHTML = `| ${Shopify.formatMoney(eachDiscountedItem, window.theme.settings.moneyWithoutCurrencyFormat)} each`;
            this.section.querySelectorAll('.curated-pack-pricing').forEach(el => {
              el.querySelector('.price__current').innerHTML = Shopify.formatMoney(remainingTotal, window.theme.settings.moneyWithoutCurrencyFormat);
              el.querySelector('.price__was').innerHTML = Shopify.formatMoney(totalPrice, window.theme.settings.moneyWithoutCurrencyFormat);
              el.querySelector('.product-label--sale span').classList.remove('hidden');
              el.querySelector('.product-label--sale span').innerText = `${Math.round(discount)}% Off`;
              el.classList.remove('hidden');
            });
          }
          this.querySelector('.single-discount').classList.add('hidden');
          this.querySelector('.pack-each-price').classList.remove('hidden');
          this.section.querySelectorAll('.pack-pricing').forEach(el => el.classList.add('hidden'));
          this.section.querySelectorAll('.single-price').forEach(el => el.classList.add('hidden'));
        }
      }

      udpateDiscountMessage(){
        if(!this.singleDiscountJson){
          return;
        }
        this.priceJson = this.singleDiscountJson.discounts;
        
        this.discountMessage = this.querySelector('.single-discount');
        if(this.totalQuantity > 0){
          // Find the next pricing tier the user can reach
          const pricingTiers = this.priceJson;
          let nextTier = null;

          if(this.totalQuantity < pricingTiers[0].pack && this.validateQtyBuild){
            this.inValid = true;
          }else{
            this.inValid = false;
          }

          for (let i = 0; i < pricingTiers.length; i++) {
            if (this.totalQuantity < pricingTiers[i].pack) {
              nextTier = pricingTiers[i];
              break;
            }
          }
          let t = 0;

          for (let i = 0; i < pricingTiers.length; i++) {
            if (this.totalQuantity >= pricingTiers[i].pack) {
              t = pricingTiers[i];
            }
            if (this.totalQuantity < pricingTiers[i].pack) {
              nextTier = pricingTiers[i];
              break;
            }
          }

          /*if (nextTier) {
            let text = this.discountMessage.dataset.addMoreMsg;
            text = text.replace('PACK', nextTier.pack - this.totalQuantity);
            text = text.replace('PERCENT', nextTier.display_discount);
            this.discountMessage.textContent = text;
          } else {
            // User has reached or exceeded the last tier
            const lastTier = pricingTiers[pricingTiers.length - 1];
            this.discountMessage.textContent = `Reached max discount of ${lastTier.display_discount}% Off`;
          }*/

          if(this.totalQuantity != t.pack && this.totalQuantity > 0){
            const totalDiscountPerQty = t.discount*this.variantData.variants[0].price/100;
            const totalAmount = this.variantData.variants[0].price*this.totalQuantity/100;
            const totalDiscount = totalDiscountPerQty*t.pack/100;
            // const finalDiscount = totalAmount - totalDiscount;
            const newPercentage = (totalDiscount / totalAmount)*100;
            // console.log(t, totalAmount, totalDiscount, finalDiscount, newPercentage);
            if(newPercentage > 0){
              t.display_discount = Math.round(newPercentage);
            }
          }
        }else{
          this.discountMessage.textContent = this.discountMessage.dataset.selectMsg;
          this.inValid = true;
        }
      }

      selectQuantityPacksData(){
        this.selectedPackQuantityData = this.packData.formattedDiscountPrice.find(p => p.pack == this.selectedPackQuantity);
      }

      updateOptions(evt){
        // console.log(this.selectedPack);
        this.selectedVariants = [];
        const selectedVariants = [];
        this.availableVariants = [];
        const colorsList = [];

        if(!this.selectedPack){
          return;
        }
        this.selectedPack.colors.forEach(color => {
          colorsList.push(color.value);
          const variants = this.variantData.variants.filter(v => v.options[0] === color.value);
          variants.forEach(variant => {
            const exists = this.availableVariants.find(v => v.id === variant.id);
            if (!exists) {
              this.availableVariants.push({ ...variant, qty: color.qty });
            }
          });
        });

        this.selectedPack.colors.forEach(color => {
          const variant = this.variantData.variants.find(v => v.options[0] === color.value);

          if (variant) {
            selectedVariants.push({...variant, qty: color.qty});
          }
        });
        this.updateOptionAvailabilityCurated(this.availableVariants, colorsList);
        
        this.selectedVariants = this.selectedPack.colors.flatMap(color => {
          return this.variantData.variants
            .filter(v => {
              if (v.options[0] !== color.value) return false;

              return this.selectedOptions.every((opt, i) => {
                if (i === 0) return true; // color already handled
                return opt === null || v.options[i] === opt;
              });
            })
            .map(v => ({ ...v, qty: color.qty }));
        });

        if(this.selectedVariants.length > 0 && this.selectedVariants.length == colorsList.length){
          this.appendLineItems();
        }else{
          this.productForm.querySelector('.pack-inputs').innerHTML = ``;
          this.selectedVariants = selectedVariants;
        }

        // console.log(evt);
        if(evt.target.closest('.option-selector').classList.contains('option-selector--custom')){
          this.dispatchEvent(new CustomEvent('on:curated_pack_variant:change', {
            bubbles: true,
            detail: {
              form: this.productForm,
              variants: this.selectedVariants,
              allVariants: this.data.variants,
              selectedOptions: this.selectedOptions,
              packSelectedOptions: this.packSelectedOptions,
              selectedPack: this.selectedPack
            }
          }));
        }
      }

      updateQuantity(evt){
        // console.log(evt);
        if(this.packType == 'single'){
          const quantity = parseInt(evt.detail.quantity);
          // console.log(quantity);

          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: 'pdp_click',
            eventParameter:{
              event_trigger_type: 'select_quantity_click',
              event_trigger_value: quantity,
              quantity: quantity,
              previous_quantity: this.totalQuantity
            },
            custom_event_label: 'select_quantity_click',
            custom_event_value: quantity
          });
          
          this.totalQuantity = quantity;
          this.updatePriceAndDiscount();
        }
      }

      updateOptionAvailabilityCurated(availableVariants, colorsList){
        const selectedOptions = [];
        this.querySelectorAll('.option-selector:not(.option-selector--custom)').forEach(selector => {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        });
        this.selectedOptions = selectedOptions;
        this.selectedOptions[0] = colorsList;
        // const selectedVariants = [];
        this.querySelectorAll('.option-selector:not(.option-selector--custom)').forEach((selector, selectorIndex) => {
          // if(selector.dataset.option != 'Packs Quantity' && selector.dataset.option != 'Color'){
          // if(selectorIndex > 2){
            const options = selector.querySelectorAll('.js-option:not([data-value=""]):not(.custom-select__option-exclude)');
            const colors = this.selectedOptions[0];

            options.forEach((option) => {
              const optionValue = selector.dataset.selectorType === 'dropdown'
                ? option.dataset.value
                : option.value;

              let variantsExist = true;
              let variantsAvailable = true;

              colors.forEach(color => {
                const matchedVariants = availableVariants.filter(v => {
                  return (
                    v.options[0] === color &&
                    v.options[selectorIndex] === optionValue &&
                    this.selectedOptions.every((sel, i) => {
                      if (i === 0) return true; // skip color (already handled)
                      if (i === selectorIndex) return true;
                      return sel === null || v.options[i] === sel;
                    })
                  );
                });

                if (matchedVariants.length === 0) {
                  variantsExist = false;
                  variantsAvailable = false;
                  return;
                }

                if (!matchedVariants.some(v => v.available)) {
                  variantsAvailable = false;
                }
              });

              if (selector.dataset.option !== 'Color') {
                VariantPickerCuratedPacks.updateOptionAvailability(
                  option,
                  variantsExist,
                  variantsAvailable
                );
              }
            });
          // }
        });

        this.selectedVariants = this.selectedPack.colors.flatMap(color => {
          return this.variantData.variants
            .filter(v => {
              if (v.options[0] !== color.value) return false;

              return this.selectedOptions.every((opt, i) => {
                if (i === 0) return true; // color already handled
                return opt === null || v.options[i] === opt;
              });
            })
            .map(v => ({ ...v, qty: color.qty }));
        });

        this.mainVariantContainer.querySelectorAll('.packs-colors-picker input').forEach(el => {
          el.classList.remove('is-unavailable');
        });

        const isAllSelected = this.selectedOptions.filter(v => v != null);
        
        if(isAllSelected.length == this.selectedOptions.length){
          // console.log(this.selectedOptions, this.variantData.variants);

          // const isValid = this.selectedPack.colors.every(color => {
          //   const totalInventory = this.selectedVariants
          //     .filter(v => v.options[0] === color.value)
          //     .reduce((sum, v) => sum + (v.inventory_quantity || 0), 0);

          //   return totalInventory >= color.qty;
          // });
          
          const filterOtherPackColors = this.packData.packs.filter(pack => pack.pack == this.selectedPackQuantity);
          
          if(filterOtherPackColors){
            filterOtherPackColors.forEach(packD => {
              const colors = packD.colors;
              const isValid = colors.every(color => {
                const totalInventory = this.variantData.variants
                  .filter(v => {
                    return this.selectedOptions.every((opt, index) => {
                      // replace color option value dynamically
                      const valueToCheck =
                        index === 0
                          ? color.value
                          : opt;

                      return v.options[index] === valueToCheck;
                    })
                  })
                  .reduce((sum, v) => sum + (v.inventory_quantity || 0), 0);
                
                return totalInventory >= color.qty;
              });
              
              if(!isValid){
                this.packColorSelector.querySelector(`[data-pack-value="${packD.id}"]`).classList.add('is-unavailable');
              }
              if(this.packColorSelector.querySelector(`[data-pack-value="${packD.id}"]`).checked == true){
                this.updateAddToCartButton(isValid);
              }
            });
          }
        }
        
        // if(this.selectedVariants.length == colorsList.length){
        //   const isValid = this.selectedPack.colors.every(color => {
        //     const totalInventory = this.selectedVariants
        //       .filter(v => v.options[0] === color.value)
        //       .reduce((sum, v) => sum + (v.inventory_quantity || 0), 0);

        //     return totalInventory >= color.qty;
        //   });
        //   console.log(isValid);
        //   this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');

        //   this.addBtn.disabled = !isValid;
        //   this.addBtn.classList.remove('is-error');
        //   this.addBtn.setAttribute('aria-disabled', !isValid);

        //   if(isValid == false){
        //     this.mainVariantContainer.querySelector('.packs-colors-picker input:checked').classList.add('is-unavailable');
        //     this.addBtn.classList.add('is-error');
        //     this.addBtn.textContent = theme.strings.noStock;
        //   }else{
        //     this.addBtn.classList.remove('is-error');
        //     this.addBtn.textContent = this.addBtn.dataset.addToCartText;
        //   }
        //   // this.mainVariantContainer.querySelector('.packs-colors-picker input:checked').classList.toggle('is-unavailable', !isValid);
        // }
      }

      updateAddToCartButton(status){
        this.section.querySelector('.buy-buttons-row').classList.remove('hidden');
        this.section.querySelector('.notify-back-in-stock-container').classList.add('hidden');

        this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
        this.addBtn.disabled = false;
        
        if(status == false){
          this.addBtn.disabled = true;
          this.addBtn.textContent = theme.strings.noStock;
        }else{
          this.addBtn.textContent = this.addBtn.dataset.addToCartText;
        }
      }
      
      static updateOptionAvailability(optionEl, exists, available) {
        const el = optionEl;
        const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle('is-unavailable', !available);
        // el.disabled = !available;
        el.disabled = false;
        el.classList.toggle('is-nonexistent', !exists);

        if (optionEl.classList.contains('custom-select__option')) {
          const em = el.querySelector('em');

          if (em) {
            em.hidden = available;
          }

          if (!available) {
            if (em) {
              em.textContent = unavailableText;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
            }
          }
        } else if (!available) {
          el.nextElementSibling.title = unavailableText;
        } else {
          el.nextElementSibling.removeAttribute('title');
        }
      }

      filterPacks(evt){
        const packQty = evt.target.value;
        // this.selectedPackQuantity = packQty;
        this.selectQuantityPacksData();
        
        // const filterColorPacks = this.packColorSelector.querySelectorAll(`.pack-color-wrapper`).filter(el => {
        //   // el.dataset.packQty == packQty == false ? el.classList.add('hidden') : '';
        //   return el.dataset.packQty == packQty;
        // });
        let newPacks = true;
        this.packColorSelector.querySelector('.packs-colors-picker').classList.remove('packs-color-expanded');
        this.packColorSelector.querySelectorAll(`.pack-color-wrapper`).forEach(el => {
          el.dataset.packQty == packQty ? el.classList.remove('hidden') : el.classList.add('hidden');
          if(this.selectedPack != null && el.dataset.packQty == packQty && el.querySelector('input').dataset.packValue == this.selectedPack.id){
            newPacks = false;
          }
        });
        this.packColorSelector.querySelector('.show-more-btn').classList.add('hidden');

        const filterColorPacks = [...this.packColorSelector.querySelectorAll('.swatch-wrapper:not(.hidden)')];
        
        filterColorPacks.forEach((el, i) => {
          if (i >= 4) el.classList.add('hidden-by-limit');
        });
        
        if (filterColorPacks.length > 4) {
          filterColorPacks[4].before(this.packColorSelector.querySelector('.show-more-btn'));
          this.packColorSelector.querySelector('.show-more-btn').classList.remove('hidden');
        }
        // this.packColorSelector.querySelectorAll(`.pack-color-wrapper`).forEach(el => {
        //   el.dataset.packQty == packQty ? el.classList.remove('hidden') : el.classList.add('hidden');
        // });
        const filterPacks = this.packData;

        if(this.selectedPack && newPacks == false){
          this.packColorSelector.querySelector(`.pack-color-wrapper input[data-pack-value="${this.selectedPack.id}"]`).checked = true;
          this.packColorSelector.querySelector(`.pack-color-wrapper input[data-pack-value="${this.selectedPack.id}"]`).dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));

          const index = [...this.packColorSelector.querySelectorAll('.pack-color-wrapper:not(.hidden)')]
            .findIndex(el =>
              el.querySelector(`input[data-pack-value="${this.selectedPack.id}"]`)
            );
          
          if(index > 3){
            this.packColorSelector.querySelector('.show-more-btn').dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
          }
        }else{
          this.packColorSelector.querySelectorAll(`.pack-color-wrapper:not(.hidden)`)[0].querySelector('input[type="radio"]').checked = true;
          this.packColorSelector.querySelectorAll(`.pack-color-wrapper:not(.hidden)`)[0].querySelector('input[type="radio"]').dispatchEvent(new Event('change', { bubbles: true, cancelable: true }))
        }
        this.packColorSelector.querySelector('.mobile-packs-color-slider').scrollTo({
          left: 0,
          behavior: 'smooth'
        });

        // this.section.querySelectorAll('.curated-pack-pricing').forEach(el => {
        //   el.querySelector('.price__current').innerHTML = this.selectedPackQuantityData.price;
        //   el.querySelector('.price__was').innerHTML = this.selectedPackQuantityData.compareAtPrice;
        // });
        // this.packColorSelector.querySelectorAll(`.pack-color-wrapper[data-pack-qty="${packQty}"]`).classList.remove('hidden');
      }

      appendLineItems(){
        if(!this.selectedVariants) return;

        this.querySelector('.line-items [name="properties[__pack_id]"]').value = this.selectedPack.id;
        if(this.querySelector('.line-items [name="properties[__pack_data]"]')){
          this.querySelector('.line-items [name="properties[__pack_data]"]').value = JSON.stringify({
            img: this.selectedPack.image
          });
        }
        this.querySelector('.line-items [name="properties[_bundle_title]"]').value = `Curated ${this.selectedPack.pack} Pack`;
        // this.querySelector('.line-items [name="properties[_bundle_number]"]').value = this.selectedPack.id;
        const idData = this.selectedVariants.map(v => { return {'id':v.id, 'quantity': v.qty, 'color': v.options[0]}});
        // console.log(idData);
        this.querySelector('.line-items [name="ids"]').value = JSON.stringify(idData);
        this.productForm.querySelector('.pack-inputs').innerHTML = this.querySelector('.line-items').innerHTML;
      }

      getPackData(){
        const dataEl = this.querySelector('#curated-pack-data[type="application/json"]');
        return JSON.parse(dataEl.textContent);
      }

      getCuratedPackDiscountData(){
        const dataEl = this.querySelector('#curated-discount-json[type="application/json"]');
        return JSON.parse(dataEl.textContent);
      }

      getSinglesDiscountData(){
        const dataEl = this.querySelector('#singles-discount-json[type="application/json"]');
        if(dataEl)
          return JSON.parse(dataEl.textContent);

        return null;
      }

    }
    customElements.define('variant-picker-curated-packs', VariantPickerCuratedPacks)
  }
}

if (!customElements.get('back-in-stock')) {
  class BackInStock extends HTMLElement{
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.bisForm = this.querySelector('.notify-bis-form');
      this.errorContainer = this.querySelector('.bis-error');

      this.bisForm.addEventListener('submit', this.handleSubmit.bind(this));
    }

    handleSubmit(evt){
      evt.preventDefault();

      const formValid = this.validate();
    
      if (!formValid) return;

      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "email": this.querySelector('.custom-option__text-input-email').value,
                  }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": "$shopify:::$default:::"+this.productForm.querySelector('[name="id"]').value
              }
            }
          }
        }
      }

      var requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2025-10-15"
          },
          body: JSON.stringify(payload),
      };

      const res = fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=PjKgix",requestOptions)
          .then(result => console.log(result))
          .catch(error => console.log('error', error));

      // console.log(res);
      if(res.errors){
        this.errorContainer.innerHTML = `<p>${res.errors[0].detail}</p>`;
      }else{
        const payload = {
          "data": {
            "type": "subscription",
            "attributes": {
              "custom_source":"form",
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": this.querySelector('.custom-option__text-input-email').value,
                  },
                },
              },
            },
            "relationships": {
              "list": {
                "data": {
                  "type": "list",
                  "id": "NqCekM"
                }
              }
            }
          }
        }

        var requestOptions = {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "revision":"2025-10-15"
            },
            body: JSON.stringify(payload),
        };

        const res = fetch("https://a.klaviyo.com/client/subscriptions/?company_id=PjKgix",requestOptions)
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

        if(res.errors){

        }else{
          this.bisForm.reset();
          this.querySelector('.success-msg').innerHTML = `<p>You're in! We'll let you know when it's back</p>`;
        }
      }
    }

    validate(){
      let isValid = true;
      this.errorContainer.innerHTML = '';
      const emailValue = this.querySelector('.custom-option__text-input-email');
      if(emailValue.value == '' || emailValue.value == undefined){
        // this.errorContainer.innerHTML = `<p>Please enter a valid email address.</p>`;
        emailValue.placeholder = 'Please enter a valid email address.';
        emailValue.classList.add('error');
        isValid = false;
      }else{
        emailValue.placeholder = 'Email Address';
        emailValue.classList.remove('error');
      }
      if(this.querySelector('.custom-option__text-input-terms-agree').checked){
        this.errorContainer.innerHTML = '';
      }else{
        this.errorContainer.innerHTML = `<p>Please select terms conditions</p>`;
        isValid = false;
      }

      return isValid;
    }
  }

  customElements.define('back-in-stock', BackInStock);
}

